import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'

function useTourV2VerticalName(): string {
  const intl = useIntl()
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(() => {
    if (config.CRUISES_REGIONS?.split(',').includes(currentRegionCode)) {
      return intl.formatMessage({
        id: 'zyiNM6Tsg6MqMw0QXHB7',
        defaultMessage: 'Tours',
        description: 'Vertical name label for tours when cruises are shown as a separate vertical',
      })
    }

    return intl.formatMessage({
      id: 'zzVfmgF3eOcvESMoDL7y',
      defaultMessage: 'Tours & Cruises',
      description: 'Vertical name label for the combined tours and cruises vertical',
    })
  }, [intl, currentRegionCode])
}

export default useTourV2VerticalName
